import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {HomeComponent} from './home/home.component';
import {WorkComponent} from './work/work.component';
import {EducationComponent} from './education/education.component';
import {ResultsComponent} from './results/results.component';
import {SpeakingComponent} from './speaking/speaking.component';
import {ContactComponent} from './contact/contact.component';
import {Page404Component} from './page404/page404.component';
import {DeepcrawlComponent} from './work/deepcrawl/deepcrawl.component';
import {DiscipleComponent} from './work/disciple/disciple.component';
import {AllotmentDigitalComponent} from './work/allotment-digital/allotment-digital.component';
import {VinnaComponent} from './work/vinna/vinna.component';
import {InfringementReportComponent} from './work/infringement-report/infringement-report.component';
import {RegusComponent} from './results/regus/regus.component';
import {TheSpaceComponent} from './results/the-space/the-space.component';

const routes: Routes = [
  {path: 'home', redirectTo: '', pathMatch: 'full'},
  {path: '', component: HomeComponent},
  {path: 'work', component: WorkComponent},
  {path: 'work/deepcrawl', component: DeepcrawlComponent},
  {path: 'work/disciple', component: DiscipleComponent},
  {path: 'work/allotment-digital', component: AllotmentDigitalComponent},
  {path: 'work/infringement-report', component: InfringementReportComponent},
  {path: 'work/vinna', component: VinnaComponent},
  {path: 'education', component: EducationComponent},
  {path: 'results', component: ResultsComponent},
  {path: 'results/regus', component: RegusComponent},
  {path: 'results/the-space', component: TheSpaceComponent},
  {path: 'speaking', component: SpeakingComponent},
  {path: 'contact', component: ContactComponent},
  {path: '**', component: Page404Component}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}



// WEBPACK FOOTER //
// /opt/buildhome/repo/src/app/app-routing.module.ts